const ITEMS = [
  "FIREWATCH · HOT-WORK SAFETY",
  "OSHA 10 / 30 · MARITIME 1915",
  "DBIDS · BASE ACCESS READINESS",
  "STRUCTURAL WELDING",
  "MARINE PIPEFITTING",
  "HEAVY RIGGING",
  "MARINE ELECTRICAL",
  "NAVAL DRYDOCK PLACEMENT",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="relative border-y border-white/10 bg-[#10161F] py-4 overflow-hidden">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="mx-8 font-display font-black uppercase text-lg sm:text-2xl tracking-tight text-[#8FA3B8] inline-flex items-center gap-8">
            {t}
            <span className="h-2 w-2 rotate-45 bg-[#FF5E1E]" />
          </span>
        ))}
      </div>
    </section>
  );
}
